<h2 mat-dialog-title>{{ titleKey | translate }}</h2>

<form (ngSubmit)="save()">
  <mat-dialog-content class="content">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'access.userForm.email' | translate }}</mat-label>
      <input
        matInput
        type="email"
        name="email"
        required
        placeholder="naam@organisatie.nl"
        [(ngModel)]="email"
        [disabled]="data.mode !== 'add'"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'access.userForm.name' | translate }}</mat-label>
      <input matInput type="text" name="name" [(ngModel)]="name" />
    </mat-form-field>

    <fieldset>
      <legend>{{ (data.multipleRoles ? 'access.userForm.roles' : 'access.userForm.role') | translate }}</legend>
      @if (data.multipleRoles) {
        @for (role of data.roles; track role.code) {
          <mat-checkbox
            [checked]="selectedRoles().includes(role.code)"
            (change)="toggleRole(role.code, $event.checked)"
          >{{ role.name }}</mat-checkbox>
        }
      } @else {
        <mat-radio-group class="roles" [value]="selectedRoles()[0]" (change)="selectRole($event.value)">
          @for (role of data.roles; track role.code) {
            <mat-radio-button [value]="role.code">{{ role.name }}</mat-radio-button>
          }
        </mat-radio-group>
      }
    </fieldset>

    @if (data.mode === 'add') {
      <p class="hint">{{ 'access.userForm.addHint' | translate }}</p>
    }

    @if (error()) {
      <p class="error" role="alert">{{ error() | translate }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'access.userForm.cancel' | translate }}</button>
    <button mat-flat-button type="submit" [disabled]="saving()">
      {{ (data.mode === 'approve' ? 'access.manager.approve' : 'access.userForm.save') | translate }}
    </button>
  </mat-dialog-actions>
</form>
